import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useAssistitiIntolleranzeDataSource(assistitoId:string) {
    const api = new AssistitiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getAssistitoIntolleranze({ tenantId: currentTenant.Id, assistitoId: assistitoId });
          },
    
          byKey: (key) => {
            return api.getAssistitoIntolleranzaById({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                intolleranzaId: key
            });
          },
    
          insert: (values) => {
            return api.insertAssistitoIntolleranza({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId, 
                assistitoIntolleranzaCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateAssistitoIntolleranza({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                intolleranzaId: key,
                assistitoIntolleranzaUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteAssistitoIntolleranza({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                intolleranzaId: key
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


